import { render, staticRenderFns } from "./TableRender.vue?vue&type=template&id=8576f468"
import script from "./TableRender.vue?vue&type=script&lang=ts"
export * from "./TableRender.vue?vue&type=script&lang=ts"
import style0 from "./TableRender.vue?vue&type=style&index=0&id=8576f468&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports